import * as R from "ramda";

const searchedData = (state) =>
  R.pathOr('', ["searchResultReducer", "searchedData"], state);
const loadData = (state) =>
  R.pathOr({}, ["searchResultReducer", "loadData"], state);
const randomChart = (state) =>
  R.pathOr({}, ["searchResultReducer", "randomChart"], state);
const search = (state) =>
  R.pathOr("", ["searchResultReducer", "search"], state);
const barChart = (state) =>
  R.pathOr([], ["searchResultReducer", "barChart"], state);

const selector = {
  searchedData,
  loadData,
  randomChart,
  search,
  barChart
};
export default selector;
